import axios from "axios";
const Checkout = () => {
    const outerModel = queryStringToJSON(window.location.search)
    function queryStringToJSON(queryString: any) {
        if (queryString.indexOf('?') > -1) {
            queryString = queryString.split('?')[1];
        }
        var pairs = queryString.split('&');
        var result: any = {};
        pairs.forEach(function (pair: any) {
            pair = pair.split('=');
            result[pair[0]] = decodeURIComponent(pair[1] || '');
        });
        return result;
    }
    const checkout = () => {
        var model = {
            Amount: outerModel.amount || "1",
            VendorName: outerModel.vendorName || "Hamza Shop",
            AppName: outerModel.appName || "APP_NAME_TEST+1",
            ClientId: outerModel.cliendId || "2e29fc3c-72bc-4603-83a4-a9fbde190496",
            Language: outerModel.language || "en",
            Currency: outerModel.currency || "Tsh",
            ExternalId: outerModel.externalId || "",
            RedirectSuccessURL: outerModel.redirectSuccessURL || `${process.env.REACT_APP_PAYMENTS_URL}payment/success`,
            RedirectFailURL: outerModel.redirectFailURL || `${process.env.REACT_APP_PAYMENTS_URL}payment/fail`,

            Cart: {
                Items: [
                    {
                        Name: outerModel.productName || "Delux Leather Jacket"
                    }
                ]
            }
        };


        axios.post(`${process.env.REACT_APP_CHECKOUT_SERVICE_URL}/api/v1/Partner/PostCheckout`, model).then(response => {
            console.log("it's worked!!!", response.data);
            // for local host
            // const url = response.data.split("/?")[1];
            // window.location.href = process.env.REACT_APP_PAYMENTS_URL + "?" + url;
            window.location.href = response.data;
        }).catch(err => {
            console.log("err...", err);
        });
    }
    return (
        <div>
            {/*---- Include the above in your HEAD tag --------*/}
            <div className="container">
                <link
                    href="https://cdnjs.cloudflare.com/ajax/libs/twitter-bootstrap/3.3.0/css/bootstrap.min.css"
                    rel="stylesheet"
                    id="bootstrap-css"
                />
                <div className="row" style={{ paddingTop: '25px', paddingBottom: '25px' }}>
                    <div className="col-md-12">
                        <div id="mainContentWrapper">
                            <div className="col-md-8 col-md-offset-2">
                                <h2 style={{ textAlign: 'center' }}>
                                    Review Your Order &amp; Complete Checkout
                                </h2>
                                <hr />
                                <div className="shopping_cart">
                                    <form className="form-horizontal" role="form" action="post" id="payment-form">
                                        <div className="panel-group" id="accordion">
                                            <div className="panel panel-default">
                                                <div className="panel-heading">
                                                    <h4 className="panel-title">
                                                        <a data-toggle="collapse" data-parent="#accordion" href="#collapseOne">
                                                            Review
                                                            Your Order
                                                        </a>
                                                    </h4>
                                                </div>
                                                <div id="collapseOne" className="panel-collapse collapse in">
                                                    <div className="panel-body">
                                                        <div className="items">
                                                            <div className="col-md-9">
                                                                <table className="table table-striped">
                                                                    <tbody><tr>
                                                                        <td colSpan={2} style={{ border: '1px solid #ddd' }}>
                                                                            <svg style={{ marginTop: '5px' }} xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="currentColor" className="bi bi-shop" viewBox="0 0 16 16">
                                                                                <path d="M2.97 1.35A1 1 0 0 1 3.73 1h8.54a1 1 0 0 1 .76.35l2.609 3.044A1.5 1.5 0 0 1 16 5.37v.255a2.375 2.375 0 0 1-4.25 1.458A2.371 2.371 0 0 1 9.875 8 2.37 2.37 0 0 1 8 7.083 2.37 2.37 0 0 1 6.125 8a2.37 2.37 0 0 1-1.875-.917A2.375 2.375 0 0 1 0 5.625V5.37a1.5 1.5 0 0 1 .361-.976l2.61-3.045zm1.78 4.275a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 1 0 2.75 0V5.37a.5.5 0 0 0-.12-.325L12.27 2H3.73L1.12 5.045A.5.5 0 0 0 1 5.37v.255a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0zM1.5 8.5A.5.5 0 0 1 2 9v6h1v-5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v5h6V9a.5.5 0 0 1 1 0v6h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1V9a.5.5 0 0 1 .5-.5zM4 15h3v-5H4v5zm5-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-3zm3 0h-2v3h2v-3z" />
                                                                            </svg>
                                                                            <b>
                                                                                <label htmlFor="vendorName" className="col-sm-11 col-form-label" id="vendorName">{outerModel.vendorName}</label>
                                                                            </b>
                                                                        </td>
                                                                    </tr>
                                                                        <tr>
                                                                            <td>
                                                                                <ul>
                                                                                    <li>Amount</li>
                                                                                </ul>
                                                                            </td>
                                                                            <td>
                                                                                <b> <label htmlFor="vendorName" className="col-sm-10 col-form-label" id="amount">{outerModel.amount}</label>
                                                                                </b></td>
                                                                        </tr>
                                                                    </tbody></table>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div style={{ textAlign: 'center' }}>
                                                                    <h3>Order Total</h3>
                                                                    <h3><span style={{ color: 'green' }}>{outerModel.amount}</span></h3>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <input id="checkoutBtn" onClick={checkout} type="button" name="btn1" value="Checkout by Azampay" className="btn btn-info col-md-offset-5 col-md-2"></input>
            </div>
        </div>
    )
}

export default Checkout;